import { render, staticRenderFns } from "./SocialFeedBase.vue?vue&type=template&id=79a368b1&"
import script from "./SocialFeedBase.vue?vue&type=script&lang=js&"
export * from "./SocialFeedBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports